import { render, staticRenderFns } from "./InstallationAndDeliveryDetails.vue?vue&type=template&id=4b2f1582&scoped=true"
import script from "./InstallationAndDeliveryDetails.vue?vue&type=script&lang=ts"
export * from "./InstallationAndDeliveryDetails.vue?vue&type=script&lang=ts"
import style0 from "./InstallationAndDeliveryDetails.vue?vue&type=style&index=0&id=4b2f1582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f1582",
  null
  
)

export default component.exports